<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <table class="announcementTable">
        <tr>
            <td class="announcement_left">
                <span>  <img  src="/assets/images/notifications_icon.png"></span>
            </td>
            <td class="announcement_right">
                <span>
                    <!-- Due to Ongoing Maintenance activity the invoice payment service will not be available from 04/24/2020 to 04/26/2020. -->
                    <!-- <p *ngFor="let announcement of AnnouncementDetails">                        
                    {{announcement.createdDate}} - {{announcement.description}} -->
                    </span>
            </td>
        </tr>
    </table>
</div>